// Application colours
const Colors = {
    TEXT: '#333333',
    SECONDARY: '#636B74',
    HINT: '#9e9e9e',
    CONTENT_BACKGROUND: '#f5f5f5',
    CONTENT_BACKGROUND_LIGHT: '#fafafa',
    CONTROLLER_BACKGROUND: '#F0F4F8',
    APP_BACKGROUND: '#f3f6f9',
    BORDER_COLOR: '#e8e8e8',
    BLUE: '#6880E2',
    BLUE_TINT: '#01a0ec',
    RED: '#c7474a',
    GREEN: '#82c64e',
    YELLOW: '#ffc836',
    ORANGE: '#ff9c2e',
    PURPLE: '#7f39fb',
    NAV: '#27364c',
    NAV_DARK: '#1d2b3e',
}

export default Colors
